import { render } from "./SkeletonPlaceholder.vue?vue&type=template&id=4698b753&scoped=true"
import script from "./SkeletonPlaceholder.vue?vue&type=script&lang=js"
export * from "./SkeletonPlaceholder.vue?vue&type=script&lang=js"

import "./SkeletonPlaceholder.vue?vue&type=style&index=0&id=4698b753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4698b753"]])

export default __exports__